var installedModules = {};
var moduleToHandlerMapping = {
	85683: {
		getter: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	30299: {
		getter: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.5.3 || ^7.4.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	17015: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	61425: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	63999: {
		getter: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.5.3 || ^7.4.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	28589: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	18717: {
		getter: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	4710: {
		getter: () => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	98179: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=14.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	31698: {
		getter: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	90434: {
		getter: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	97049: {
		getter: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=14.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	96230: {
		getter: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=13",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	10888: {
		getter: () => (() => (__webpack_require__(/*! @angular/router */ 95072))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=13",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	57148: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=13",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	92673: {
		getter: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	3388: {
		getter: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.5.3 || ^7.5.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	19736: {
		getter: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.5.3 || ^7.5.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	19869: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	63858: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-details */ 89487))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-details",
	},
	7011: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	67487: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-badge */ 39319))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-badge",
	},
	81239: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-icon */ 49175))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-icon",
	},
	9965: {
		getter: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	36406: {
		getter: () => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	49499: {
		getter: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	38496: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-button */ 29321))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-button",
	},
	7375: {
		getter: () => (() => (__webpack_require__(/*! @angular/router */ 95072))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	56705: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui */ 21919))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui",
	},
	26464: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util */ 57863))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util",
	},
	1887: {
		getter: () => (() => (__webpack_require__(/*! @ngrx/store */ 81383))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/store",
	},
	24131: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-state-store */ 72495))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-state-store",
	},
	47339: {
		getter: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	62597: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-events */ 48815))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-events",
	},
	55152: {
		getter: () => (() => (__webpack_require__(/*! @auth0/angular-jwt */ 92389))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~5.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@auth0/angular-jwt",
	},
	21451: {
		getter: () => (() => (__webpack_require__(/*! @auth0/auth0-angular */ 37989))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.3.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@auth0/auth0-angular",
	},
	186: {
		getter: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0 || ^21.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	87984: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0 || ^21.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	4697: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/models-environment */ 50831))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/models-environment",
	},
	59516: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-loading */ 67935))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-loading",
	},
	11831: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-tooltip */ 74231))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-tooltip",
	},
	67183: {
		getter: () => (() => (__webpack_require__(/*! @popperjs/core */ 41280))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.11.8",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@popperjs/core",
	},
	63159: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-context-menu */ 47347))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-context-menu",
	},
	57864: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-tag */ 87191))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-tag",
	},
	82048: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-dialog */ 94869))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-dialog",
	},
	95122: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-alert */ 68824))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-alert",
	},
	94211: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-logging */ 62943))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-logging",
	},
	52865: {
		getter: () => (() => (__webpack_require__(/*! @angular/forms */ 34456))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	38984: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/domain-logic */ 73467))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/domain-logic",
	},
	43999: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-toast */ 57103))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-toast",
	},
	6263: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-form-controls */ 59175))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-form-controls",
	},
	72458: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-tooltip-trigger */ 93715))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-tooltip-trigger",
	},
	15644: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-list */ 67909))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-list",
	},
	39828: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-search-control */ 59689))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-search-control",
	},
	93534: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-search */ 89605))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-search",
	},
	40307: {
		getter: () => (() => (__webpack_require__(/*! @angular/forms */ 34456))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	89304: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-off-canvas */ 46137))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-off-canvas",
	},
	52147: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/domain-logic */ 35492))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/domain-logic",
	},
	99914: {
		getter: () => (() => (__webpack_require__(/*! @ngrx/store */ 81383))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/store",
	},
	2851: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-tab */ 51215))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-tab",
	},
	22387: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	88231: {
		getter: () => (() => (__webpack_require__(/*! @popperjs/core */ 41280))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.11.8",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@popperjs/core",
	},
	27153: {
		getter: () => (() => (__webpack_require__(/*! @angular/router */ 95072))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	56691: {
		getter: () => (() => (__webpack_require__(/*! jszip */ 45834))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.10.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "jszip",
	},
	8573: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-stepper */ 32575))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-stepper",
	},
	66372: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-table */ 8191))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-table",
	},
	75608: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-pagination */ 84085))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-pagination",
	},
	43746: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-panel */ 19591))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-panel",
	},
	59078: {
		getter: () => (() => (__webpack_require__(/*! @microsoft/applicationinsights-web */ 75205))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/applicationinsights-web",
	},
	38701: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/feature-load-remote */ 31935))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/feature-load-remote",
	},
	66352: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-file-upload */ 35571))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-file-upload",
	},
	94968: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/feature-navigation-bar */ 75891))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/feature-navigation-bar",
	},
	78669: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-allowance-details */ 1101))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-allowance-details",
	},
	38698: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-card */ 86881))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-card",
	},
	12086: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-title-bar */ 78647))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-title-bar",
	},
	68439: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-main */ 93055))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-main",
	},
	2443: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-allowance-list */ 52071))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-allowance-list",
	},
	12023: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-entity-header */ 11567))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-entity-header",
	},
	61257: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-list-pane */ 61527))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-list-pane",
	},
	50983: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-corporate-details */ 99228))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-corporate-details",
	},
	14852: {
		getter: () => (__webpack_require__.e("node_modules_userpilot_lib_index_js").then(() => (() => (__webpack_require__(/*! userpilot */ 52768))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "userpilot",
	},
	38407: {
		getter: () => (__webpack_require__.e("node_modules_ngrx_store-devtools_fesm2022_ngrx-store-devtools_mjs").then(() => (() => (__webpack_require__(/*! @ngrx/store-devtools */ 11925))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/store-devtools",
	},
	39049: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/feature-authorization */ 60087))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/feature-authorization",
	},
	57459: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-corporate-list */ 83716))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-corporate-list",
	},
	9479: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-vat-details */ 65340))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-vat-details",
	},
	94563: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-vat-list */ 79012))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-vat-list",
	},
	81429: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-report-list */ 7437))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-report-list",
	},
	79123: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-report-details */ 17735))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-report-details",
	},
	50473: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-donation-list */ 58857))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-donation-list",
	},
	98239: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-donation-details */ 1771))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-donation-details",
	},
	26915: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-income-details */ 83426))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-income-details",
	},
	20275: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-income-list */ 30462))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-income-list",
	},
	27460: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-wage-list */ 79987))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-wage-list",
	},
	35210: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-wage-details */ 65265))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-wage-details",
	},
	26382: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-dividend-list */ 21090))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-dividend-list",
	},
	19306: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-dividend-details */ 33790))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-dividend-details",
	},
	12060: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-muma-list */ 91343))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-muma-list",
	},
	41546: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-muma-details */ 99685))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-muma-details",
	},
	29966: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-uitstel-list */ 73365))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-uitstel-list",
	},
	77324: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-uitstel-details */ 79743))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-uitstel-details",
	},
	50610: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-bezwaar-list */ 37999))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-bezwaar-list",
	},
	6224: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-bezwaar-details */ 74725))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-bezwaar-details",
	},
	63183: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-workflow-list */ 21376))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-workflow-list",
	},
	21371: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-workflow-details */ 9712))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-workflow-details",
	},
	77250: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-sba-list */ 78101))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-sba-list",
	},
	57988: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-sba-details */ 76972))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-sba-details",
	},
	32778: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-tasks-list */ 11359))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-tasks-list",
	},
	67780: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-venture/fiscaal/feature-tax-tasks-details */ 21845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-venture/fiscaal/feature-tax-tasks-details",
	}
};
var initialConsumes = [85683,30299,17015,61425,63999,28589,18717,4710,98179,31698,90434,97049,96230,10888,57148,92673,3388,19736,19869,63858,7011,67487,81239,9965,36406,49499,38496,7375,56705,26464,1887,24131,47339,62597,55152,21451,186,87984,4697,59516,11831,67183,63159,57864,82048,95122,94211,52865,38984,43999,6263,72458,15644,39828,93534,40307,89304,52147,99914,2851,22387,88231,27153,56691,8573,66372,75608,43746,59078,38701,66352,94968,78669,38698,12086,68439,2443,12023,61257,50983,85683,30299,17015,61425,63999,28589,18717,4710,98179,31698,90434,97049,96230,10888,57148,92673,3388,19736,19869,63858,7011,67487,81239,9965,36406,49499,38496,7375,56705,26464,1887,24131,47339,62597,55152,21451,186,87984,4697,59516,11831,67183,63159,57864,82048,95122,94211,52865,38984,43999,6263,72458,15644,39828,93534,40307,89304,52147,99914,2851,22387,88231,27153,56691,8573,66372,75608,43746,59078,38701,66352,94968,78669,38698,12086,68439,2443,12023,61257,50983,85683,30299,17015,61425,63999,28589,18717,4710,98179,31698,90434,97049,96230,10888,57148,92673,3388,19736,19869,63858,7011,67487,81239,9965,36406,49499,38496,7375,56705,26464,1887,24131,47339,62597,55152,21451,186,87984,4697,59516,11831,67183,63159,57864,82048,95122,94211,52865,38984,43999,6263,72458,15644,39828,93534,40307,89304,52147,99914,2851,22387,88231,27153,56691,8573,66372,75608,43746,59078,38701,66352,94968,78669,38698,12086,68439,2443,12023,61257,50983];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"main": [
		85683,
		30299,
		17015,
		61425,
		63999,
		28589,
		18717,
		4710,
		98179,
		31698,
		90434,
		97049,
		96230,
		10888,
		57148,
		92673,
		3388,
		19736,
		19869,
		63858,
		7011,
		67487,
		81239,
		9965,
		36406,
		49499,
		38496,
		7375,
		56705,
		26464,
		1887,
		24131,
		47339,
		62597,
		55152,
		21451,
		186,
		87984,
		4697,
		59516,
		11831,
		67183,
		63159,
		57864,
		82048,
		95122,
		94211,
		52865,
		38984,
		43999,
		6263,
		72458,
		15644,
		39828,
		93534,
		40307,
		89304,
		52147,
		99914,
		2851,
		22387,
		88231,
		27153,
		56691,
		8573,
		66372,
		75608,
		43746,
		59078,
		38701,
		66352,
		94968,
		78669,
		38698,
		12086,
		68439,
		2443,
		12023,
		61257,
		50983
	],
	"polyfills": [
		85683,
		30299,
		17015,
		61425,
		63999,
		28589,
		18717,
		4710,
		98179,
		31698,
		90434,
		97049,
		96230,
		10888,
		57148,
		92673,
		3388,
		19736,
		19869,
		63858,
		7011,
		67487,
		81239,
		9965,
		36406,
		49499,
		38496,
		7375,
		56705,
		26464,
		1887,
		24131,
		47339,
		62597,
		55152,
		21451,
		186,
		87984,
		4697,
		59516,
		11831,
		67183,
		63159,
		57864,
		82048,
		95122,
		94211,
		52865,
		38984,
		43999,
		6263,
		72458,
		15644,
		39828,
		93534,
		40307,
		89304,
		52147,
		99914,
		2851,
		22387,
		88231,
		27153,
		56691,
		8573,
		66372,
		75608,
		43746,
		59078,
		38701,
		66352,
		94968,
		78669,
		38698,
		12086,
		68439,
		2443,
		12023,
		61257,
		50983
	],
	"styles": [
		85683,
		30299,
		17015,
		61425,
		63999,
		28589,
		18717,
		4710,
		98179,
		31698,
		90434,
		97049,
		96230,
		10888,
		57148,
		92673,
		3388,
		19736,
		19869,
		63858,
		7011,
		67487,
		81239,
		9965,
		36406,
		49499,
		38496,
		7375,
		56705,
		26464,
		1887,
		24131,
		47339,
		62597,
		55152,
		21451,
		186,
		87984,
		4697,
		59516,
		11831,
		67183,
		63159,
		57864,
		82048,
		95122,
		94211,
		52865,
		38984,
		43999,
		6263,
		72458,
		15644,
		39828,
		93534,
		40307,
		89304,
		52147,
		99914,
		2851,
		22387,
		88231,
		27153,
		56691,
		8573,
		66372,
		75608,
		43746,
		59078,
		38701,
		66352,
		94968,
		78669,
		38698,
		12086,
		68439,
		2443,
		12023,
		61257,
		50983
	],
	"apps_ventures_fiscaal_src_bootstrap_ts": [
		14852,
		38407,
		39049
	],
	"apps_ventures_fiscaal_src_app_fiscaal_fiscaal_module_ts": [
		57459,
		9479,
		94563,
		81429,
		79123,
		50473,
		98239,
		26915,
		20275,
		27460,
		35210,
		26382,
		19306,
		12060,
		41546,
		29966,
		77324,
		50610,
		6224,
		63183,
		21371,
		77250,
		57988,
		32778,
		67780
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}